import React, { useCallback, useState } from 'react';
import Icon from '../Icon';
import LoadingSpinner from '../LoadingSpinner';

type Variant = 'product' | 'checkout'

interface ExpressCheckoutButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    onClick: () => Promise<string>;
    variant: Variant;
}

const baseClass = 'btn btn--large mt-5 flex gap-4 flex-grow self-stretch relative bg-primary-500 border border-solid border-primary-500 font-satoshi-bold font-satoshi text-white';

const variantClasses: { [key in Variant]: string } = {
    product: `${baseClass} opacity-80 `,
    checkout: `${baseClass} w-full btn--primary`,
};

const ExpressCheckoutButton = (props: ExpressCheckoutButtonProps) => { 

    const [isloading, setIsLoading] = useState(false);
    const [errorText, setErrorText] = useState('');

    const handleOnClick = async () => {
        setIsLoading(true);
        const errorMessage = await props.onClick();
        if (errorMessage) {
            setErrorText(errorMessage)
        }
        setIsLoading(false);
    }

    const LoadingComponent = useCallback(
        () => (
            <>
                &nbsp;
                <span className="flex items-center justify-center absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 mx-auto [&_svg]:w-4 [&_svg]:h-4 [&_svg]:lg:w-6 [&_svg]:lg:h-6">
                    <LoadingSpinner />
                </span>
            </>
        ),
        []
    );

    return (
        <>
            <button
                disabled={isloading}
                onClick={handleOnClick}
                className={`${variantClasses[props.variant]}`}
            >
                {isloading ? <LoadingComponent /> : (
                    <>
                        <span className="leading-none">Betal med</span>
                        <Icon name="vipps-white" className="-mx-5 !w-20 !h-20" />{' '}
                        <span className="leading-none">Hurtigkasse</span>
                    </>
                )
                }

            </button>

            {errorText && errorText.length > 0 && (
                <p className="text-error-500 mt-2 text-sm">
                    {errorText}
                </p>
            )}
        </>

    )
}

export default ExpressCheckoutButton;